import React from "react";
import { DatePicker } from "antd";
import { dateRangePresets, disableFutureDates } from "../../../services/util";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

const { RangePicker } = DatePicker;

const DateRangePicker = ({ selectedDates, setSelectedDates }) => {
    function handleDateChange(e) {
        let start_date =
            e !== null ? dayjs(e[0]).startOf("day") : selectedDates[0];
        let end_date =
            e !== null ? dayjs(e[1]).startOf("day") : selectedDates[1];
        setSelectedDates([start_date, end_date]);
    }

    return (
        <RangePicker
            allowClear={false}
            disabledDate={disableFutureDates}
            defaultValue={[dayjs(selectedDates[0]), dayjs(selectedDates[1])]}
            value={[dayjs(selectedDates[0]), dayjs(selectedDates[1])]}
            className="dashboard-date-search margin-right-5 select-container"
            onChange={handleDateChange}
            format="MM/DD/YYYY"
            presets={dateRangePresets}
        />
    );
};

export default DateRangePicker;
